import axios from 'axios';
import router from '../router';

let state = {


    operatingCurrentSplus: { value: undefined, invalid: undefined },

    // SCH-MOD Modul
    schmod_locationProductionSelection: [],
    schmod_ProdApSelection: [],
    schmod_PSGSizeSelection: [],
    schmod_motorIDSelection: [],
    schmod_motorCOSNameSelection: [],
    schmod_motorVoltageSelection: [],
    schmod_inverterTypeSelection: [],
    schmod_cableLengthSelection: [],
    schmod_cableLengthBrakeSelection: [],
    schmod_handWheelSelection: [],
    schmod_handReleaseSelection: [],
    schmod_grooveSelection: [],
    schmod_numberOfGroovesSelection: [],
    schmod_certificationSelection: [],


    schmod_locationProduction: undefined,
    schmod_ProAp: undefined,
    schmod_PSGSize: undefined,
    schmod_motorID: undefined,
    schmod_motorCOSName: undefined,
    schmod_motorVoltage: undefined,
    schmod_controller: undefined,
    schmod_cableLength: undefined,
    schmod_cableLengthBrake: undefined,
    schmod_handWheel: undefined,
    schmod_handRelease: undefined,
    schmod_grooveDistance: { value: undefined, invalid: undefined },
    schmod_groove: undefined,
    schmod_numberOfGrooves: undefined,
    schmod_certification: undefined,
    schModDetails: undefined,


    schmod_orderStatusMotorCable: {},
    schmod_orderStatusMotorCableSelected: undefined,
    schmod_orderStatusEncoderCable: {},
    schmod_orderStatusEncoderCableSelected: undefined,
    schmod_orderStatusMotorProtectionCable: {},
    schmod_orderStatusMotorProtectionCableSelected: undefined,
    schmod_orderStatusBrakeCable: {},
    schmod_orderStatusBrakeCableSelected: undefined,
    schmod_orderStatusBrakeMonitoringCable: {},
    schmod_orderStatusBrakeMonitoringCableSelected: undefined,
    schmod_orderStatusForcedVentilationCable: {},
    schmod_orderStatusForcedVentilationCableSelected: undefined,

    schmod_Valid: false,

    schmodMotordetails: undefined,
    showSCHMOD: false,
    psgMagic: false,
    psgMenu: false,

    motorDataSch: {},
}

const actions = {
    async get_SCHMOD_allSelections_storeAction({ commit, dispatch }) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            await this.commit('inputsManual/change_sM250_TS280_storeMutation', false);
            await dispatch('get_motorIpSelection_argument_storeAction');
            await dispatch('get_forcedVentilationSelection_argument_storeAction');
            await dispatch('get_deliverTractionSheaveSelection_argument_storeAction');
            await dispatch('get_machiningForHandWheelSelection_argument_storeAction');
            await dispatch('get_tractionSheave_DiameterAndWidthSelection_argument_storeAction');
            await dispatch('get_SCHMOD_tractionSheavedetails_storeAction');
            await this.dispatch('ropeGuardManual/change_ropeGuardArgument_storeAction');
            await this.dispatch('ropeGuardManual/get_customerIdKidSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_deliverRopeSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_tractionSheaveCoverSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_positionMotorSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_ropePullSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_adjustabilitySelection_storeAction');
            await this.dispatch('ropeGuardManual/get_thirdRopeGuard_storeAction');
            await this.dispatch('ropeGuardManual/get_ropeClampSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_rescueReturnDeviceSelection_storeAction');
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
        await commit('set_showSCHMOD_storeMutation', false);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },
    async get_motorIpSelection_argument_storeAction({ rootState, commit, dispatch,rootGetters }) {
        var motorIp = null;
        if (rootState.inputsManual.motorIpSelection != null && rootState.inputsManual.motorIpSelection.length > 0) {
            const firstIndex_whichMeetConditions_motorIp = rootState.inputsManual.motorIpSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions_motorIp > -1) {
                motorIp = rootState.inputsManual.motorIpSelection[firstIndex_whichMeetConditions_motorIp].text;
            }
        }

        if (rootGetters['inputsManual/hasMotorManualData']) {
            motorIp = rootState.inputsManual.motorManualData.details.mip;
        }
        const data = {
            kid: rootState.manualHome.kid,
            motorType: state.motorDataSch.mtyp,
            motorSize: state.motorDataSch.mbg,
            motorPackage: state.motorDataSch.mfe,
            motorZusatz: state.motorDataSch.mzus,
            motorVoltage: state.motorDataSch.smU1,
            motorRatedSpeed: state.motorDataSch.mnr,
            temperatureMonitoring: state.motorDataSch.msart,
            sM250_TS280: state.motorDataSch.sM250_TS280,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            motorIp: motorIp,
            pSG_ProdAP: (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null,
        }
        await this.dispatch('inputsManual/get_motorIpSelection_storeAction', data)
    },
    async get_forcedVentilationSelection_argument_storeAction({ rootState, commit, dispatch, rootGetters }) {
        var motorIp = null;
        if (rootState.inputsManual.motorIpSelection != null && rootState.inputsManual.motorIpSelection.length > 0) {
            const firstIndex_whichMeetConditions_motorIp = rootState.inputsManual.motorIpSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions_motorIp > -1) {
                motorIp = rootState.inputsManual.motorIpSelection[firstIndex_whichMeetConditions_motorIp].text;
            }
        }

        if (rootGetters['inputsManual/hasMotorManualData']) {
            motorIp = rootState.inputsManual.motorManualData.details.mip;
        }

        var mfbtyp = rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.mfbtyp : rootGetters['inputsManual/MFBTYP'];


        const data = {
            kid: rootState.manualHome.kid,
            motorType: state.motorDataSch.mtyp,
            motorSize: state.motorDataSch.mbg,
            motorPackage: state.motorDataSch.mfe,
            motorZusatz: state.motorDataSch.mzus,
            motorVoltage: state.motorDataSch.smU1,
            motorRatedSpeed: state.motorDataSch.mnr,
            temperatureMonitoring: state.motorDataSch.msart,
            motorIp: motorIp,
            sM250_TS280: state.motorDataSch.sM250_TS280,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            mfbtyp: mfbtyp,
            pSG_ProdAP: (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null,
        }
        await this.dispatch('inputsManual/get_forcedVentilationSelection_storeAction', data);
    },

    async get_deliverTractionSheaveSelection_argument_storeAction({ rootState, commit, dispatch, rootGetters }) {
        var ltr = rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.ltr : rootState.tractionSheaveManual.deliverTractionSheave;
        var psg_ProdAP = (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null;

        const data = {
            motorType: state.motorDataSch.mtyp,
            motorSize: state.motorDataSch.mbg,
            motorPackage: state.motorDataSch.mfe,
            motorZusatz: state.motorDataSch.mzus,
            temperatureMonitoring: state.motorDataSch.msart,
            sM250_TS280: state.motorDataSch.sM250_TS280,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            ltr: ltr,
            pSG_ProdAP: psg_ProdAP
        }

        await this.dispatch('tractionSheaveManual/get_deliverTractionSheaveSelection_storeAction', data)
    },
    async get_machiningForHandWheelSelection_argument_storeAction({ rootState, commit, dispatch }) {
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            lTHD: rootState.psgModal.motorDataSch.lthd,
            pSG_ProdAP: (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null,
        }
        await this.dispatch('tractionSheaveManual/get_machiningForHandWheelSelection_storeAction', data);
    },
    async get_tractionSheave_DiameterAndWidthSelection_argument_storeAction({ rootState, commit, dispatch, rootGetters }) {
        var tractionSheaveDiameter = (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.hasOwnProperty('diameter')) ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter : null;
        var tractionSheaveWidth = (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.hasOwnProperty('width')) ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width : null;
        if (rootGetters['inputsManual/hasMotorManualData']) {
            tractionSheaveDiameter = rootState.inputsManual.motorManualData.details.td;
            tractionSheaveWidth = rootState.inputsManual.motorManualData.details.tb;
        }

        var psg_ProdAP = (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null;
        var psg_Voltage = (state.motorSchModData != null) ? state.motorSchModData.psG_Voltage : null;
        var psg_GlobalID_BG = (state.motorSchModData != null) ? state.motorSchModData.psG_GlobalID_BG : null;
        var psg_MotorID = (state.motorSchModData != null) ? state.motorSchModData.psG_MotorID : null;
        var psg_NAM = (state.motorSchModData != null) ? state.motorSchModData.psG_NAM : null;
        var psg_Rillenform = (state.motorSchModData != null) ? state.motorSchModData.psG_Rillenform : null;

        const data = {
            motorType: state.motorDataSch.mtyp,
            motorSize: state.motorDataSch.mbg,
            motorPackage: state.motorDataSch.mfe,
            motorZusatz: state.motorDataSch.mzus,
            temperatureMonitoring: state.motorDataSch.msart,
            sM250_TS280: state.motorDataSch.sM250_TS280,
            kid: rootState.manualHome.kid,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            tractionSheaveDiameter: tractionSheaveDiameter,
            tractionSheaveWidth: tractionSheaveWidth,
            psg_NAM: psg_NAM,
            psg_ProdAP: psg_ProdAP,
            psg_Voltage: psg_Voltage,
            psg_GlobalID_BG: psg_GlobalID_BG,
            psg_MotorID: psg_MotorID,
            psg_Rillenform: psg_Rillenform,
        }
        await this.dispatch('tractionSheaveManual/get_tractionSheave_DiameterAndWidthSelection_storeAction', data);
    },

    change_operatingCurrentSplus_storeAction({ commit }, value) {
        if (value != null && value.trim() != '') {
            const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
            valueAndValueValidationCriteria.value = value;
            valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.decimal;
            valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = 2;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 0;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThan;

            const operatingCurrentSplus_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

            commit('change_operatingCurrentSplus_storeMutation', operatingCurrentSplus_ValidationResult);
        }
        else {
            commit('change_operatingCurrentSplus_storeMutation', { value: null, invalid: null });
        }
    },

    set_defaultValues_storeAction({ commit }) {
        //commit('change_operatingCurrentSplus_storeMutation', { value: undefined, invalid: undefined });
        //commit('change_SCHMOD_locationProductionSelection_storeMutation', []);
        //commit('change_SCHMOD_ProdApSelection_storeMutation', []);

        //commit('change_SCHMOD_PSGSizeSelection_storeMutation', []);
        //commit('change_SCHMOD_motorIDSelection_storeMutation', []);
        //commit('change_SCHMOD_motorCOSNameSelection_storeMutation', []);
        //commit('change_SCHMOD_motorVoltageSelection_storeMutation', []);
        //commit('change_SCHMOD_inverterTypeSelection_storeMutation', []);
        //commit('change_SCHMOD_cableLengthSelection_storeMutation', []);
        //commit('change_SCHMOD_cableLengthBrakeSelection_storeMutation', []);
        //commit('change_SCHMOD_handWheelSelection_storeMutation', []);
        //commit('change_SCHMOD_handReleaseSelection_storeMutation', []);
        //commit('change_SCHMOD_grooveSelection_storeMutation', []);
        //commit('change_SCHMOD_numberOfGroovesSelection_storeMutation', []);
        //commit('change_SCHMOD_certificationSelection_storeMutation', []);
        //commit('change_SCHMOD_locationProduction_storeMutation', undefined);
        //commit('change_SCHMOD_ProAp_storeMutation', undefined);
        //commit('change_SCHMOD_PSGSize_storeMutation', undefined);
        //commit('change_SCHMOD_motorID_storeMutation', undefined);
        //commit('change_SCHMOD_motorCosName_storeMutation', undefined);
        //commit('change_SCHMOD_motorVoltage_storeMutation', undefined);
        //commit('change_SCHMOD_cableLength_storeMutation', undefined);
        //commit('change_SCHMOD_cableLengthBrake_storeMutation', undefined);
        //commit('change_SCHMOD_handWheel_storeMutation', undefined);
        //commit('change_SCHMOD_handRelease_storeMutation', undefined);
        //commit('change_SCHMOD_grooveDistance_storeMutation', { value: undefined, invalid: undefined });
        //commit('change_SCHMOD_groove_storeMutation', undefined);
        //commit('change_SCHMOD_numberOfGrooves_storeMutation', undefined);
        //commit('change_SCHMOD_certification_storeMutation', undefined);
        //commit('change_SchModDetails_storeMuation', undefined);

        //commit('change_SCHMOD_orderStatusMotorCable_storeMutation', {});
        //commit('change_SCHMOD_orderStatusEncoderCable_storeMutation', {});
        //commit('change_SCHMOD_orderStatusMotorProtectionCable_storeMutation', {});
        //commit('change_SCHMOD_orderStatusBrakeCable_storeMutation', {});
        //commit('change_SCHMOD_orderStatusBrakeMonitoringCable_storeMutation', {});
        //commit('change_SCHMOD_orderStatusForcedVentilationCable_storeMutation', {});

        //commit('change_schmod_Valid_storeMuation', false);

        //commit('change_SCHMOD_Motordetails_storeMutation', undefined);
        commit('set_showSCHMOD_storeMutation', false);
        commit('change_SCH_magic_storeMutation', false);
        commit('change_SCH_psgMenu_storeMutation', false);

    },

    // SCH-MOD Modul
    async set_endPSG_storeAction({ commit, dispatch, rootState }) {
        commit('change_SCH_magic_storeMutation', false);
        this.commit('inputsManual/change_motorManualData_storeMutation', null);
        commit('change_SchModDetails_storeMuation', null);
        commit('change_motorSchModData_storeMutation', null);
        await commit('change_forcedVentilationSelection_storeMutation', []);
        await dispatch('set_inputManual_toDefault_storeAction');
        await dispatch('set_inputManual_SCHMOD_toDefault_storeAction');
        await commit('set_showSCHMOD_storeMutation', false);
        dispatch('inputsManual/set_inputsManual_storeAction');
        if (rootState.manualHome.kid == 'SCH-MOD') {
            commit('set_showSCHMOD_storeMutation', true);
            dispatch('get_SCHMOD_DefaultAndValuelists_storeAction');
        }
    },
    async set_cancelPSG_storeAction({ commit, dispatch }) {
        await commit('set_showSCHMOD_storeMutation', false);
        dispatch('inputsManual/set_inputsManual_storeAction');
    },
    async change_SCH_psgMenu_storeAction({ rootState, dispatch, commit }, value) {
        await dispatch('check_SCHMOD_storeAction');
    },
    async check_SCHMOD_storeAction({ rootState, commit, dispatch }) {
        await commit('set_showSCHMOD_storeMutation', true);
        await dispatch('get_SCHMOD_DefaultAndValuelists_storeAction');
    },

    async get_SCHMOD_DefaultAndValuelists_storeAction({ commit, dispatch, rootState }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            psgMagic: state.psgMagic,
            psgMenu: state.psgMenu,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_DefaultAndValuelists',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_locationProductionSelection_storeMutation', response.data.data.locationProductionSelection);
                if (state.schmod_locationProductionSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_locationProductionSelection.findIndex(i => (i.text.text == state.schmod_locationProduction));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_locationProduction_storeAction', state.schmod_locationProductionSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_locationProductionSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_locationProduction_storeAction', state.schmod_locationProductionSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_certificationSelection_storeMutation', response.data.data.certificationSelection);
                if (state.schmod_certificationSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_certificationSelection.findIndex(i => (i.text.text == state.schmod_certification));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_certification_storeAction', state.schmod_certificationSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_certificationSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_certification_storeAction', state.schmod_certificationSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_ProdApSelection_storeMutation', response.data.data.prodApSelection);
                if (state.schmod_ProdApSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_ProdApSelection.findIndex(i => (i.text.text == state.prodAP));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_ProAp_storeAction', state.schmod_ProdApSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_ProdApSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_ProAp_storeAction', state.schmod_ProdApSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_PSGSizeSelection_storeMutation', response.data.data.psgSizeSelection);
                if (state.schmod_PSGSizeSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_PSGSizeSelection.findIndex(i => (i.text.text == state.schmod_PSGSize));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_PSGSize_storeAction', state.schmod_PSGSizeSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_PSGSizeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_PSGSize_storeAction', state.schmod_PSGSizeSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_motorIDSelection_storeMutation', response.data.data.motorIDSelection);
                if (state.schmod_motorIDSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_motorIDSelection.findIndex(i => (i.text.text == state.schmod_motorID));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_motorID_storeAction', state.schmod_motorIDSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_motorIDSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_motorID_storeAction', state.schmod_motorIDSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_motorCOSNameSelection_storeMutation', response.data.data.motorCOSNameSelection);
                if (state.schmod_motorCOSNameSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_motorCOSNameSelection.findIndex(i => (i.text.text == state.schmod_motorCOSName));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_motorCosName_storeAction', state.schmod_motorCOSNameSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_motorCOSNameSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_motorCosName_storeAction', state.schmod_motorCOSNameSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_motorVoltageSelection_storeMutation', response.data.data.motorVoltageSelection);
                if (state.schmod_motorVoltageSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_motorVoltageSelection.findIndex(i => (i.value == state.schmod_motorVoltage));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_motorVoltage_storeAction', state.schmod_motorVoltageSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_motorVoltageSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_motorVoltage_storeAction', state.schmod_motorVoltageSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_inverterTypeSelection_storeMutation', response.data.data.inverterTypeSelection);
                if (state.schmod_inverterTypeSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_inverterTypeSelection.findIndex(i => (i.text.text == state.schmod_controller));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_inverterType_storeAction', state.schmod_inverterTypeSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_inverterTypeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_inverterType_storeAction', state.schmod_inverterTypeSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_cableLengthSelection_storeMutation', response.data.data.cableLengthSelection);
                if (state.schmod_cableLengthSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_cableLengthSelection.findIndex(i => (i.text.text == state.schmod_cableLength));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_cableLength_storeAction', state.schmod_cableLengthSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_cableLengthSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_cableLength_storeAction', state.schmod_cableLengthSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_cableLengthBrakeSelection_storeMutation', response.data.data.cableLengthBrakeSelection);
                if (state.schmod_cableLengthBrakeSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_cableLengthBrakeSelection.findIndex(i => (i.text.text == state.schmod_cableLengthBrake));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_cableLengthBrake_storeAction', state.schmod_cableLengthBrakeSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_cableLengthBrakeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_cableLengthBrake_storeAction', state.schmod_cableLengthBrakeSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_handWheelSelection_storeMutation', response.data.data.handWheelSelection);
                if (state.schmod_handWheelSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_handWheelSelection.findIndex(i => (i.text.text == state.schmod_handWheel));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_handWheel_storeAction', state.schmod_handWheelSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_handWheelSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_handWheel_storeAction', state.schmod_handWheelSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_handReleaseSelection_storeMutation', response.data.data.handReleaseSelection);
                if (state.schmod_handReleaseSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_handReleaseSelection.findIndex(i => (i.text.text == state.schmod_handRelease));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_handRelease_storeAction', state.schmod_handReleaseSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_handReleaseSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_handRelease_storeAction', state.schmod_handReleaseSelection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_grooveSelection_storeMutation', response.data.data.grooveSelection);
                const firstIndex_whichMeetConditions_groove = state.schmod_grooveSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions_groove > -1) {
                    dispatch('change_SCHMOD_grooves_storeAction', state.schmod_grooveSelection[firstIndex_whichMeetConditions_groove]);
                }
                commit('change_SCHMOD_numberOfGroovesSelection_storeMutation', response.data.data.numberOfGroovesSelection);
                const firstIndex_whichMeetConditions_numberOfGrooves = state.schmod_numberOfGroovesSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions_numberOfGrooves > -1) {
                    dispatch('change_SCHMOD_numberOfGrooves_storeAction', state.schmod_numberOfGroovesSelection[firstIndex_whichMeetConditions_numberOfGrooves]);
                }
                commit('change_SchModDetails_storeMuation', response.data.data.schModDetails);

                commit('change_SCHMOD_orderStatusMotorCableSelection_storeMutation', response.data.data.orderStatus_MotorCable);
                if (state.schmod_orderStatusMotorCable.hasOwnProperty('selection') && state.schmod_orderStatusMotorCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusMotorCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusMotorCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusMotorCable_storeAction', state.schmod_orderStatusMotorCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusMotorCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusMotorCable_storeAction', state.schmod_orderStatusMotorCable.selection[firstIndex_whichMeetConditions]);
                        }
                    }
                }
                commit('change_SCHMOD_orderStatusEncoderCableSelection_storeMutation', response.data.data.orderStatus_EncoderCable);
                if (state.schmod_orderStatusEncoderCable.hasOwnProperty('selection') && state.schmod_orderStatusEncoderCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusEncoderCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusEncoderCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusEncoderCable_storeAction', state.schmod_orderStatusEncoderCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusEncoderCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusEncoderCable_storeAction', state.schmod_orderStatusEncoderCable.selection[firstIndex_whichMeetConditions]);
                        }
                    }
                }

                commit('change_SCHMOD_orderStatusMotorProtectionCableSelection_storeMutation', response.data.data.orderStatus_MotorProtectionCable);
                if (state.schmod_orderStatusMotorProtectionCable.hasOwnProperty('selection') && state.schmod_orderStatusMotorProtectionCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusMotorProtectionCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusMotorProtectionCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusMotorProtectionCable_storeAction', state.schmod_orderStatusMotorProtectionCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusMotorProtectionCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusMotorProtectionCable_storeAction', state.schmod_orderStatusMotorProtectionCable.selection[firstIndex_whichMeetConditions]);
                        }
                    }
                }

                commit('change_SCHMOD_orderStatusBrakeCableSelection_storeMutation', response.data.data.orderStatus_BrakeCable);
                if (state.schmod_orderStatusBrakeCable.hasOwnProperty('selection') && state.schmod_orderStatusBrakeCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusBrakeCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusBrakeCable_storeAction', state.schmod_orderStatusBrakeCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusBrakeCable_storeAction', state.schmod_orderStatusBrakeCable.selection[firstIndex_whichMeetConditions]);
                        }
                    }
                }

                commit('change_SCHMOD_orderStatusBrakeMonitoringCableSelection_storeMutation', response.data.data.orderStatus_BrakeMonitoringCable);
                if (state.schmod_orderStatusBrakeMonitoringCable.hasOwnProperty('selection') && state.schmod_orderStatusBrakeMonitoringCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeMonitoringCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusBrakeMonitoringCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusBrakeMonitoringCable_storeAction', state.schmod_orderStatusBrakeMonitoringCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeMonitoringCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusBrakeMonitoringCable_storeAction', state.schmod_orderStatusBrakeMonitoringCable.selection[firstIndex_whichMeetConditions]);
                        }
                    }
                }

                commit('change_SCHMOD_orderStatusForcedVentilationCableSelection_storeMutation', response.data.data.orderStatus_ForcedVentilationCable);
                if (state.schmod_orderStatusForcedVentilationCable.hasOwnProperty('selection') && state.schmod_orderStatusForcedVentilationCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusForcedVentilationCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusForcedVentilationCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusForcedVentilationCable_storeAction', state.schmod_orderStatusForcedVentilationCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusForcedVentilationCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusForcedVentilationCable_storeAction', state.schmod_orderStatusForcedVentilationCable.selection[firstIndex_whichMeetConditions]);
                        }
                    }
                }

            })
            .catch(() => {
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async get_SCHMOD_MotorVoltageSelection_storeAction({ commit, dispatch }) {

        const data = {
            locationProduction: state.schmod_locationProduction,
            prodAp: state.schmod_ProAp,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_MotorVoltageSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_motorVoltageSelection_storeMutation', response.data);
                if (state.schmod_motorVoltageSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_motorVoltageSelection.findIndex(i => (i.value == state.schmod_motorVoltage));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_motorVoltage_storeAction', state.schmod_motorVoltageSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_motorVoltageSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_motorVoltage_storeAction', state.schmod_motorVoltageSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
                if (state.schmod_inverterTypeSelection == null || state.schmod_inverterTypeSelection.length == 0) {
                }

            })
    },
    async get_SCHMOD_PSGSizeSelection_storeAction({ commit, dispatch }) {

        const data = {
            prodAp: state.schmod_ProAp,
            voltage: state.schmod_motorVoltage,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_PSGSizeSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_PSGSizeSelection_storeMutation', response.data);
                if (state.schmod_PSGSizeSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_PSGSizeSelection.findIndex(i => (i.text.text == state.schmod_PSGSize));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_PSGSize_storeAction', state.schmod_PSGSizeSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_PSGSizeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_PSGSize_storeAction', state.schmod_PSGSizeSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_SCHMOD_MotorIDSelection_storeAction({ commit, dispatch }) {
        if (state.schmod_ProAp != null && state.schmod_motorVoltage != null) {
            const data = {
                prodAp: state.schmod_ProAp,
                voltage: state.schmod_motorVoltage,
                pSG_Size: state.schmod_PSGSize,
            }

            await axios({
                method: 'post',
                url: '/api/inputsManual/get_SCHMOD_MotorIDSelection',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    commit('change_SCHMOD_motorIDSelection_storeMutation', response.data);
                    if (state.schmod_motorIDSelection.length > 0) {
                        var firstIndex_whichMeetConditions = state.schmod_motorIDSelection.findIndex(i => (i.text.text == state.schmod_motorID));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_motorID_storeAction', state.schmod_motorIDSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                            firstIndex_whichMeetConditions = state.schmod_motorIDSelection.findIndex(i => (i.selected == true));
                            if (firstIndex_whichMeetConditions > -1) {
                                dispatch('change_SCHMOD_motorID_storeAction', state.schmod_motorIDSelection[firstIndex_whichMeetConditions]);
                            }
                            else {
                            }

                        }
                    }
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },
    async get_SCHMOD_MotorCOSNameSelection_storeAction({ commit, dispatch }) {
        if (state.schmod_ProAp != null && state.schmod_motorVoltage != null) {

            const data = {
                prodAp: state.schmod_ProAp,
                voltage: state.schmod_motorVoltage,
                pSG_Size: state.schmod_PSGSize,
                cosnam: state.schmod_motorID,
            }

            await axios({
                method: 'post',
                url: '/api/inputsManual/get_SCHMOD_MotorCOSNameSelection',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    commit('change_SCHMOD_motorCOSNameSelection_storeMutation', response.data);
                    if (state.schmod_motorCOSNameSelection.length > 0) {
                        var firstIndex_whichMeetConditions = state.schmod_motorCOSNameSelection.findIndex(i => (i.text.text == state.schmod_motorCOSName));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_motorCosName_storeAction', state.schmod_motorCOSNameSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                            firstIndex_whichMeetConditions = state.schmod_motorCOSNameSelection.findIndex(i => (i.selected == true));
                            if (firstIndex_whichMeetConditions > -1) {
                                dispatch('change_SCHMOD_motorCosName_storeAction', state.schmod_motorCOSNameSelection[firstIndex_whichMeetConditions]);
                            }
                            else {
                            }

                        }
                    }
                })
                .catch(() => {
                })
                .then(() => {

                })
        }
    },
    async get_SCHMOD_InverterTypeSelection_storeAction({ commit, dispatch }) {

        const data = {
            locationProduction: state.schmod_locationProduction,
            prodAp: state.schmod_ProAp,
            pSG_Size: state.schmod_PSGSize,
            cosnam: state.schmod_motorID,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_InverterTypeSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_inverterTypeSelection_storeMutation', response.data);
                if (state.schmod_inverterTypeSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_inverterTypeSelection.findIndex(i => (i.text.text == state.schmod_controller));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_inverterType_storeAction', state.schmod_inverterTypeSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_inverterTypeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_inverterType_storeAction', state.schmod_inverterTypeSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {

            })
    },
    async get_SCHMOD_CableLengthBrakeSelection_storeAction({ commit, dispatch }) {

        const data = {
            prodAp: state.schmod_ProAp,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_CableLengthBrakeSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_cableLengthBrakeSelection_storeMutation', response.data);
                if (state.schmod_cableLengthBrakeSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_cableLengthBrakeSelection.findIndex(i => (i.text.text == state.schmod_cableLengthBrake));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_cableLengthBrake_storeAction', state.schmod_cableLengthBrakeSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_cableLengthBrakeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_cableLengthBrake_storeAction', state.schmod_cableLengthBrakeSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_SCHMOD_HandWheelSelection_storeAction({ commit, dispatch }) {

        const data = {
            prodAp: state.schmod_ProAp,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_HandWheelSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_handWheelSelection_storeMutation', response.data);
                if (state.schmod_handWheelSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_handWheelSelection.findIndex(i => (i.text.text == state.schmod_handWheel));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_handWheel_storeAction', state.schmod_handWheelSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_handWheelSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_handWheel_storeAction', state.schmod_handWheelSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_SCHMOD_GrooveSelection_storeAction({ commit, dispatch }) {

        const data = {
            prodAp: state.schmod_ProAp,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_GrooveSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_grooveSelection_storeMutation', response.data);
                const firstIndex_whichMeetConditions = state.schmod_grooveSelection.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions > -1) {
                    dispatch('change_SCHMOD_grooves_storeAction', state.schmod_grooveSelection[firstIndex_whichMeetConditions]);
                }
                else {
                }

            })
            .catch(() => {
            })
            .then(() => {

            })
    },

    change_SCHMOD_locationProduction_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_locationProduction_storeMutation', value.text.text);
        //dispatch('get_SCHMOD_ProdApSelection_storeAction');
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_ProAp_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_ProAp_storeMutation', value.text.text);
        const firstIndex_whichMeetConditions_prodAp = state.schmod_ProdApSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions_prodAp > -1) {
            dispatch('get_SCHMOD_MotorVoltageSelection_storeAction');
            dispatch('get_SCHMOD_CableLengthBrakeSelection_storeAction');
            dispatch('get_SCHMOD_HandWheelSelection_storeAction');
            dispatch('get_SCHMOD_GrooveSelection_storeAction');
        }
        commit('change_SCHMOD_PSGSize_storeMutation', null);
        commit('change_SCHMOD_motorID_storeMutation', null);
        commit('change_SCHMOD_motorCosName_storeMutation', null);

        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    async change_SCHMOD_PSGSize_storeAction({ commit, dispatch }, value) {
        if (state.schmod_ProAp != null && state.schmod_motorVoltage != null && value != null && value.hasOwnProperty('text') && value.text.text != null) {
            var filter_ProApAndUsNomAndPSGSize = state.schModDetails.filter(i => (i.prodap == state.schmod_ProAp && i.usNom == state.schmod_motorVoltage && i.psgglo == value.text.text));
            if (filter_ProApAndUsNomAndPSGSize != null && filter_ProApAndUsNomAndPSGSize.length > 0) {
                commit('change_SCHMOD_PSGSize_storeMutation', value.text.text);
                await dispatch('get_SCHMOD_MotorIDSelection_storeAction')
                if (state.schmod_motorID != null) {
                    filter_ProApAndUsNomAndPSGSize = filter_ProApAndUsNomAndPSGSize.filter(i => (i.cosnam == state.schmod_motorID));
                    if (filter_ProApAndUsNomAndPSGSize != null && filter_ProApAndUsNomAndPSGSize.length > 0) {
                    }
                    else {
                        commit('change_SCHMOD_motorID_storeMutation', null);
                    }
                    await dispatch('get_SCHMOD_MotorCOSNameSelection_storeAction')
                    await dispatch('get_SCHMOD_InverterTypeSelection_storeAction');
                }
                else {
                    await dispatch('get_SCHMOD_MotorCOSNameSelection_storeAction')
                    await dispatch('get_SCHMOD_InverterTypeSelection_storeAction');
                }
                if (state.schmod_motorCOSName != null) {
                    filter_ProApAndUsNomAndPSGSize = filter_ProApAndUsNomAndPSGSize.filter(i => (i.psgnam == state.schmod_motorCOSName));
                    if (filter_ProApAndUsNomAndPSGSize != null && filter_ProApAndUsNomAndPSGSize.length > 0) {
                    }
                    else {
                        commit('change_SCHMOD_motorCosName_storeMutation', null);
                    }
                }
            }
            else {
                commit('change_SCHMOD_PSGSize_storeMutation', null);
                await dispatch('get_SCHMOD_MotorIDSelection_storeAction')
                await dispatch('get_SCHMOD_MotorCOSNameSelection_storeAction')
                await dispatch('get_SCHMOD_InverterTypeSelection_storeAction');
            }
        }
        else {
            commit('change_SCHMOD_PSGSize_storeMutation', null);

            await dispatch('get_SCHMOD_MotorIDSelection_storeAction')
            await dispatch('get_SCHMOD_MotorCOSNameSelection_storeAction')
            await dispatch('get_SCHMOD_InverterTypeSelection_storeAction');
        }
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    async change_SCHMOD_motorID_storeAction({ commit, dispatch }, value) {
        if (state.schmod_ProAp != null && state.schmod_motorVoltage != null && value != null && value.hasOwnProperty('text') && value.text.text != null) {
            var filter_ProApAndUsNom = state.schModDetails.filter(i => (i.prodap == state.schmod_ProAp && i.usNom == state.schmod_motorVoltage && i.cosnam == value.text.text));
            if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                commit('change_SCHMOD_motorID_storeMutation', value.text.text);
                await dispatch('get_SCHMOD_MotorCOSNameSelection_storeAction')
                await dispatch('get_SCHMOD_InverterTypeSelection_storeAction');
                const filter_PSGSize = structuredClone(filter_ProApAndUsNom)
                if (state.schmod_motorCOSName != null) {
                    filter_ProApAndUsNom = filter_ProApAndUsNom.filter(i => (i.psgnam == state.schmod_motorCOSName));
                    if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                    }
                    else {
                        commit('change_SCHMOD_motorCosName_storeMutation', null);
                    }
                }
                if (state.schmod_PSGSize != null) {
                    filter_ProApAndUsNom = filter_ProApAndUsNom.filter(i => (i.psgglo == state.schmod_PSGSize));
                    if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                    }
                    else {
                        if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                            commit('change_SCHMOD_PSGSize_storeMutation', filter_ProApAndUsNom[0].psgglo);
                        }
                        else {
                            if (filter_PSGSize != null && filter_PSGSize.length > 0) {
                                commit('change_SCHMOD_PSGSize_storeMutation', filter_PSGSize[0].psgglo);
                            }
                            else {
                                commit('change_SCHMOD_PSGSize_storeMutation', null);
                            }
                        }
                    }
                }
                else {
                    if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                        commit('change_SCHMOD_PSGSize_storeMutation', filter_ProApAndUsNom[0].psgglo);
                    }
                    else {
                        if (filter_PSGSize != null && filter_PSGSize.length > 0) {
                            commit('change_SCHMOD_PSGSize_storeMutation', filter_PSGSize[0].psgglo);
                        }
                    }
                }
            }
            else {
                commit('change_SCHMOD_motorID_storeMutation', null);
                await dispatch('get_SCHMOD_MotorCOSNameSelection_storeAction')
                await dispatch('get_SCHMOD_InverterTypeSelection_storeAction');
            }
        }
        else {
            commit('change_SCHMOD_motorID_storeMutation', null);
            await dispatch('get_SCHMOD_MotorCOSNameSelection_storeAction')
            await dispatch('get_SCHMOD_InverterTypeSelection_storeAction');
        }

        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_motorCosName_storeAction({ commit, dispatch }, value) {
        if (state.schmod_ProAp != null && state.schmod_motorVoltage != null && value != null && value.hasOwnProperty('text') && value.text.text != null) {
            var filter_ProApAndUsNom = state.schModDetails.filter(i => (i.prodap == state.schmod_ProAp && i.usNom == state.schmod_motorVoltage && i.psgnam == value.text.text));
            if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                commit('change_SCHMOD_motorCosName_storeMutation', value.text.text);
                const filter_PSGSize = structuredClone(filter_ProApAndUsNom)
                if (state.schmod_motorID != null) {
                    filter_ProApAndUsNom = filter_ProApAndUsNom.filter(i => (i.cosnam == state.schmod_motorID));
                    if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                    }
                    else {
                        if (filter_PSGSize != null && filter_PSGSize.length > 0) {
                            commit('change_SCHMOD_motorID_storeMutation', filter_PSGSize[0].cosnam);
                            filter_ProApAndUsNom = filter_ProApAndUsNom.filter(i => (i.cosnam == filter_PSGSize[0].cosnam));
                        }
                        else {
                            commit('change_SCHMOD_motorID_storeMutation', null);
                        }
                    }
                }
                else {
                    if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                        commit('change_SCHMOD_motorID_storeMutation', filter_ProApAndUsNom[0].cosnam);
                        filter_ProApAndUsNom = filter_ProApAndUsNom.filter(i => (i.cosnam == filter_ProApAndUsNom[0].cosnam));
                    }
                    else {
                        commit('change_SCHMOD_motorID_storeMutation', null);
                    }
                }
                if (state.schmod_PSGSize != null) {
                    filter_ProApAndUsNom = filter_ProApAndUsNom.filter(i => (i.psgglo == state.schmod_PSGSize));
                    if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                    }
                    else {
                        if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                            commit('change_SCHMOD_PSGSize_storeMutation', filter_ProApAndUsNom[0].psgglo);
                        }
                        else {
                            if (filter_PSGSize != null && filter_PSGSize.length > 0) {
                                commit('change_SCHMOD_PSGSize_storeMutation', filter_PSGSize[0].psgglo);
                            }
                            else {
                                commit('change_SCHMOD_PSGSize_storeMutation', null);
                            }
                        }
                    }
                }
                else {
                    if (filter_ProApAndUsNom != null && filter_ProApAndUsNom.length > 0) {
                        commit('change_SCHMOD_PSGSize_storeMutation', filter_ProApAndUsNom[0].psgglo);
                    }
                    else {
                        if (filter_PSGSize != null && filter_PSGSize.length > 0) {
                            commit('change_SCHMOD_PSGSize_storeMutation', filter_PSGSize[0].psgglo);
                        }
                    }
                }
            }
            else {
                commit('change_SCHMOD_motorCosName_storeMutation', null);
            }
        }
        else {
            commit('change_SCHMOD_motorCosName_storeMutation', null);
        }
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_motorVoltage_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_motorVoltage_storeMutation', value.value);
        //const firstIndex_whichMeetConditions_prodAp = state.schmod_ProdApSelection.findIndex(i => (i.selected == true));
        //const firstIndex_whichMeetConditions_voltage = state.schmod_motorVoltageSelection.findIndex(i => (i.selected == true));
        //if (firstIndex_whichMeetConditions_prodAp > -1 && firstIndex_whichMeetConditions_voltage > -1) {
        //    dispatch('get_SCHMOD_PSGSizeSelection_storeAction')
        //}
        commit('change_SCHMOD_PSGSize_storeMutation', null);
        commit('change_SCHMOD_motorID_storeMutation', null);
        commit('change_SCHMOD_motorCosName_storeMutation', null);
        dispatch('get_SCHMOD_PSGSizeSelection_storeAction');

        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_inverterType_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_inverterType_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_cableLength_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_cableLength_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
        dispatch('change_cableLength_orderStatus_storeAction');
    },
    change_SCHMOD_cableLengthBrake_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_cableLengthBrake_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
        dispatch('change_cableLengthBrake_orderStatus_storeAction');
    },
    change_SCHMOD_handWheel_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_handWheel_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_handRelease_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_handRelease_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },

    change_cableLength_orderStatus_storeAction({ dispatch }) {
        dispatch('get_SCHMOD_orderStatusMotorCable_storeAction');
        dispatch('get_SCHMOD_orderStatusEncoderCable_storeAction')
        dispatch('get_SCHMOD_orderStatusMotorProtectionCable_storeAction');
    },
    async get_SCHMOD_orderStatusMotorCable_storeAction({ commit, dispatch }) {
        const data = {
            prodAp: state.schmod_ProAp,
            cableLength: state.schmod_cableLength,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_Orderstatus_MotorCable',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_orderStatusMotorCableSelection_storeMutation', response.data);
                if (state.schmod_orderStatusMotorCable.hasOwnProperty('selection') && state.schmod_orderStatusMotorCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusMotorCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusMotorCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusMotorCable_storeAction', state.schmod_orderStatusMotorCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusMotorCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusMotorCable_storeAction', state.schmod_orderStatusMotorCable.selection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })

    },
    async get_SCHMOD_orderStatusMotorProtectionCable_storeAction({ commit, dispatch }) {
        const data = {
            prodAp: state.schmod_ProAp,
            cableLength: state.schmod_cableLength,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_Orderstatus_MotorProtectionCable',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_orderStatusMotorProtectionCableSelection_storeMutation', response.data);
                if (state.schmod_orderStatusMotorProtectionCable.hasOwnProperty('selection') && state.schmod_orderStatusMotorProtectionCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusMotorProtectionCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusMotorProtectionCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusMotorProtectionCable_storeAction', state.schmod_orderStatusMotorProtectionCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusMotorProtectionCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusMotorProtectionCable_storeAction', state.schmod_orderStatusMotorProtectionCable.selection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_SCHMOD_orderStatusEncoderCable_storeAction({ commit, dispatch }) {
        const data = {
            prodAp: state.schmod_ProAp,
            cableLength: state.schmod_cableLength,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_Orderstatus_EncoderCable',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_orderStatusEncoderCableSelection_storeMutation', response.data);
                if (state.schmod_orderStatusEncoderCable.hasOwnProperty('selection') && state.schmod_orderStatusEncoderCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusEncoderCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusEncoderCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusEncoderCable_storeAction', state.schmod_orderStatusEncoderCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusEncoderCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusEncoderCable_storeAction', state.schmod_orderStatusEncoderCable.selection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })

    },
    change_cableLengthBrake_orderStatus_storeAction({ dispatch }) {
        dispatch('get_SCHMOD_orderStatusBrakeCable_storeAction');
        dispatch('get_SCHMOD_orderStatusBrakeMonitoringCable_storeAction')
        dispatch('get_SCHMOD_orderStatusForcedVentilationCable_storeAction');
    },
    async get_SCHMOD_orderStatusBrakeCable_storeAction({ commit, dispatch }) {
        const data = {
            prodAp: state.schmod_ProAp,
            cableLengthBrake: state.schmod_cableLengthBrake,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_Orderstatus_BrakeCable',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_orderStatusBrakeCableSelection_storeMutation', response.data);
                if (state.schmod_orderStatusBrakeCable.hasOwnProperty('selection') && state.schmod_orderStatusBrakeCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusBrakeCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusBrakeCable_storeAction', state.schmod_orderStatusBrakeCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusBrakeCable_storeAction', state.schmod_orderStatusBrakeCable.selection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_SCHMOD_orderStatusBrakeMonitoringCable_storeAction({ commit, dispatch }) {
        const data = {
            prodAp: state.schmod_ProAp,
            cableLengthBrake: state.schmod_cableLengthBrake,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_Orderstatus_BrakeMonitoringCable',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_orderStatusBrakeMonitoringCableSelection_storeMutation', response.data);
                if (state.schmod_orderStatusBrakeMonitoringCable.hasOwnProperty('selection') && state.schmod_orderStatusBrakeMonitoringCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeMonitoringCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusBrakeMonitoringCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusBrakeMonitoringCable_storeAction', state.schmod_orderStatusBrakeMonitoringCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusBrakeMonitoringCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusBrakeMonitoringCable_storeAction', state.schmod_orderStatusBrakeMonitoringCable.selection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_SCHMOD_orderStatusForcedVentilationCable_storeAction({ commit, dispatch }) {
        const data = {
            prodAp: state.schmod_ProAp,
            cableLengthBrake: state.schmod_cableLengthBrake,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_Orderstatus_ForcedVentilationCable',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_SCHMOD_orderStatusForcedVentilationCableSelection_storeMutation', response.data);
                if (state.schmod_orderStatusForcedVentilationCable.hasOwnProperty('selection') && state.schmod_orderStatusForcedVentilationCable.selection.length > 0) {
                    var firstIndex_whichMeetConditions = state.schmod_orderStatusForcedVentilationCable.selection.findIndex(i => (i.text.code == state.schmod_orderStatusForcedVentilationCableSelected));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_SCHMOD_orderStatusForcedVentilationCable_storeAction', state.schmod_orderStatusForcedVentilationCable.selection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.schmod_orderStatusForcedVentilationCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_SCHMOD_orderStatusForcedVentilationCable_storeAction', state.schmod_orderStatusForcedVentilationCable.selection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }


            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    change_SCHMOD_orderStatusMotorCable_storeAction({ commit }, value) {
        commit('change_SCHMOD_orderStatusMotorCable_storeMutation', value.text.code)
    },
    change_SCHMOD_orderStatusEncoderCable_storeAction({ commit }, value) {
        commit('change_SCHMOD_orderStatusEncoderCable_storeMutation', value.text.code)
    },
    change_SCHMOD_orderStatusMotorProtectionCable_storeAction({ commit }, value) {
        commit('change_SCHMOD_orderStatusMotorProtectionCable_storeMutation', value.text.code)
    },
    change_SCHMOD_orderStatusBrakeCable_storeAction({ commit }, value) {
        commit('change_SCHMOD_orderStatusBrakeCable_storeMutation', value.text.code)
    },
    change_SCHMOD_orderStatusBrakeMonitoringCable_storeAction({ commit }, value) {
        commit('change_SCHMOD_orderStatusBrakeMonitoringCable_storeMutation', value.text.code)
    },
    change_SCHMOD_orderStatusForcedVentilationCable_storeAction({ commit }, value) {
        commit('change_SCHMOD_orderStatusForcedVentilationCable_storeMutation', value.text.code)
    },
    change_SCHMOD_grooveDistance_storeAction({ commit, dispatch }, value) {
        if (value != null && value.trim() != '') {
            const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
            valueAndValueValidationCriteria.value = value;
            valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.integer;
            valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = null;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 20;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThan;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 300;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.lessThanOrEqualTo;
            const schmod_grooveDistance_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

            commit('change_SCHMOD_grooveDistance_storeMutation', schmod_grooveDistance_ValidationResult);
        }
        else {
            commit('change_SCHMOD_grooveDistance_storeMutation', { value: null, invalid: null });
        }
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_grooves_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_groove_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_numberOfGrooves_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_numberOfGrooves_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },
    change_SCHMOD_certification_storeAction({ commit, dispatch }, value) {
        commit('change_SCHMOD_certification_storeMutation', value.text.text);
        dispatch('checkIf_SCHMOD_inputsManual_areValid_storeAction');
    },


    async set_inputManual_SCHMOD_toDefault_storeAction({ commit }) {
        commit('change_SCHMOD_locationProductionSelection_storeMutation', []);
        commit('change_SCHMOD_ProdApSelection_storeMutation', []);
        commit('change_SCHMOD_PSGSizeSelection_storeMutation', []);
        commit('change_SCHMOD_motorIDSelection_storeMutation', []);
        commit('change_SCHMOD_motorCOSNameSelection_storeMutation', []);
        commit('change_SCHMOD_motorVoltageSelection_storeMutation', []);
        commit('change_SCHMOD_inverterTypeSelection_storeMutation', []);
        commit('change_SCHMOD_cableLengthSelection_storeMutation', []);
        commit('change_SCHMOD_cableLengthBrakeSelection_storeMutation', []);
        commit('change_SCHMOD_handWheelSelection_storeMutation', []);
        commit('change_SCHMOD_handReleaseSelection_storeMutation', []);
        commit('change_SCHMOD_grooveSelection_storeMutation', []);
        commit('change_SCHMOD_numberOfGroovesSelection_storeMutation', []);
        commit('change_SCHMOD_locationProduction_storeMutation', null);
        commit('change_SCHMOD_ProAp_storeMutation', null);
        commit('change_SCHMOD_PSGSize_storeMutation', null);
        commit('change_SCHMOD_motorID_storeMutation', null);
        commit('change_SCHMOD_motorCosName_storeMutation', null);
        commit('change_SCHMOD_motorVoltage_storeMutation', null);
        commit('change_SCHMOD_inverterType_storeMutation', null);
        commit('change_SCHMOD_cableLength_storeMutation', null);
        commit('change_SCHMOD_cableLengthBrake_storeMutation', null);
        commit('change_SCHMOD_handWheel_storeMutation', null);
        commit('change_SCHMOD_handRelease_storeMutation', null);
        commit('change_SCHMOD_grooveDistance_storeMutation', { value: null, invalid: null });
        commit('change_SCHMOD_groove_storeMutation', null);
        commit('change_SCHMOD_numberOfGrooves_storeMutation', null);
        commit('change_SCHMOD_orderStatusMotorCable_storeMutation', null);
        commit('change_SCHMOD_orderStatusEncoderCable_storeMutation', null);
        commit('change_SCHMOD_orderStatusMotorProtectionCable_storeMutation', null);
        commit('change_SCHMOD_orderStatusBrakeCable_storeMutation', null);
        commit('change_SCHMOD_orderStatusBrakeMonitoringCable_storeMutation', null);
        commit('change_SCHMOD_orderStatusForcedVentilationCable_storeMutation', null);
        commit('change_operatingCurrentSplus_storeMutation', { value: null, invalid: null });
    },


    async get_SCHMOD_tractionSheavedetails_storeAction({ rootState, commit, dispatch,rootGetters }) {
        var tractionSheaveDiameter = (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.hasOwnProperty('diameter')) ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter : null;
        var tractionSheaveWidth = (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.hasOwnProperty('width')) ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width : null;

        if (rootGetters['inputsManual/hasMotorManualData']) {
            tractionSheaveDiameter = rootState.inputsManual.motorManualData.details.td;
            tractionSheaveWidth = rootState.inputsManual.motorManualData.details.tb;
        }

        const data = {
            tractionSheaveDiameter: tractionSheaveDiameter,
            tractionSheaveWidth: tractionSheaveWidth,
            motorType: state.motorDataSch.mtyp,
            motorSize: state.motorDataSch.mbg,
            motorPackage: state.motorDataSch.mfe,
            motorZusatz: state.motorDataSch.mzus,
            temperatureMonitoring: state.motorDataSch.msart,
            sM250_TS280: state.motorDataSch.sM250_TS280,
            kid: rootState.manualHome.kid,
            lTHD: state.motorDataSch.machiningForHandWheel,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            psg_No_of_rope_Grooves: (state.motorSchModData != null) ? state.motorSchModData.psG_No_of_rope_Grooves : null,
            psg_ProdAP: (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null,
            psg_GlobalID_BG: (state.motorSchModData != null) ? state.motorSchModData.psG_GlobalID_BG : null,
            psg_Handradanbau: (state.motorSchModData != null) ? state.motorSchModData.psG_Handradanbau : null,
            psg_Rillenform: (state.motorSchModData != null) ? state.motorSchModData.psG_Rillenform : null,
            psg_Rillenabstand: (state.motorSchModData != null) ? state.motorSchModData.psG_Rillenabstand : null,
            sheaveProfile: rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.tarill : null,
            undercutAngle: rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.tauwi : null,
            vgrooveAngle: rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.takwi : null,
            ropeDiameter: rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.tcsd : null,
            grooveDistance: rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.tdra : null,
            numberOfGrooves: rootGetters['inputsManual/hasMotorManualData'] ? rootState.inputsManual.motorManualData.details.tdrz : null,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_tractionSheavedetails',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if (response.data.status.statusCode.substring(0, 1) == '2') {
                    dispatch('change_SCHMOD_tractionSheavedetails', response.data.data.tractionSheavedetails);
                }
                else {
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async change_SCHMOD_tractionSheavedetails({ rootState, dispatch, commit }, value) {
        const tractionSheaveRopeDiameterSelection = (value != null && value != undefined && value.hasOwnProperty("tractionSheaveRopeDiameterSelection")) ? value.tractionSheaveRopeDiameterSelection : null;
        const tractionSheaveGrooveDistanceSelection = (value != null && value != undefined && value.hasOwnProperty("tractionSheaveGrooveDistanceSelection")) ? value.tractionSheaveGrooveDistanceSelection : null;
        const tractionSheaveNumberOfRopesSelection = (value != null && value != undefined && value.hasOwnProperty("tractionSheaveNumberOfRopesSelection")) ? value.tractionSheaveNumberOfRopesSelection : null;
        const tractionSheaveProfilesSelection = (value != null && value != undefined && value.hasOwnProperty("tractionSheaveProfilesSelection")) ? value.tractionSheaveProfilesSelection : null;
        const tractionSheaveUndercutAngleSelection = (value != null && value != undefined && value.hasOwnProperty("tractionSheaveUndercutAngleSelection")) ? value.tractionSheaveUndercutAngleSelection : null;
        const tractionSheaveVgrooveAngleSelection = (value != null && value != undefined && value.hasOwnProperty("tractionSheaveVgrooveAngleSelection")) ? value.tractionSheaveVgrooveAngleSelection : null;
        await dispatch('change_SCHMOD_tractionSheavedetails_tractionSheaveRopeDiameterSelection', tractionSheaveRopeDiameterSelection);
        await dispatch('change_SCHMOD_tractionSheavedetails_tractionSheaveGrooveDistanceSelection', tractionSheaveGrooveDistanceSelection);
        await dispatch('change_SCHMOD_tractionSheavedetails_tractionSheaveNumberOfRopesSelection', tractionSheaveNumberOfRopesSelection);
        await dispatch('change_SCHMOD_tractionSheavedetails_tractionSheaveProfilesSelection', tractionSheaveProfilesSelection);
        await dispatch('change_SCHMOD_tractionSheavedetails_undercutAngleSelection',tractionSheaveUndercutAngleSelection);
        await dispatch('change_SCHMOD_tractionSheavedetails_vgrooveAngleSelection', tractionSheaveVgrooveAngleSelection);
    },
    async change_SCHMOD_tractionSheavedetails_tractionSheaveRopeDiameterSelection({ rootState, dispatch, commit }, value) {
        if (value != null) {
            await this.commit('tractionSheaveManual/change_TCSD_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = rootState.tractionSheaveManual.ropeDiameterSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await this.dispatch('tractionSheaveManual/change_TCSD_storeAction', rootState.tractionSheaveManual.ropeDiameterSelection[firstIndex_whichMeetConditions]);
            }
        } else {
            await this.commit('tractionSheaveManual/change_TCSD_Selection_storeMutation', []);
        }
    },
    async change_SCHMOD_tractionSheavedetails_tractionSheaveGrooveDistanceSelection({ rootState, dispatch, commit }, value) {
        if (value != null) {
            await this.commit('tractionSheaveManual/change_TDRA_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = rootState.tractionSheaveManual.grooveDistanceSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await this.dispatch('tractionSheaveManual/change_TDRA_storeAction', rootState.tractionSheaveManual.grooveDistanceSelection[firstIndex_whichMeetConditions]);
            }
        } else {
            await this.commit('tractionSheaveManual/change_TDRA_Selection_storeMutation', []);
        }
    },
    async change_SCHMOD_tractionSheavedetails_tractionSheaveNumberOfRopesSelection({ rootState, dispatch, commit }, value) {
        if (value != null) {
            await this.commit('tractionSheaveManual/change_TDRZ_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = rootState.tractionSheaveManual.numberOfGroovesSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await this.dispatch('tractionSheaveManual/change_TDRZ_storeAction', rootState.tractionSheaveManual.numberOfGroovesSelection[firstIndex_whichMeetConditions]);
            }
        } else {
            await this.commit('tractionSheaveManual/change_TDRZ_Selection_storeMutation', []);
        }
    },
    async change_SCHMOD_tractionSheavedetails_tractionSheaveProfilesSelection({ rootState, dispatch, commit }, value) {
        if (value != null) {
            await this.commit('tractionSheaveManual/change_TARILL_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = rootState.tractionSheaveManual.sheaveProfileSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await this.dispatch('tractionSheaveManual/change_TARILL_storeAction', rootState.tractionSheaveManual.sheaveProfileSelection[firstIndex_whichMeetConditions]);
            }
        } else {
            await this.commit('tractionSheaveManual/change_TARILL_Selection_storeMutation', []);
        }
    },
    async change_SCHMOD_tractionSheavedetails_undercutAngleSelection({ rootState, dispatch, commit }, value) {
        if (value != null) {
            await this.commit('tractionSheaveManual/change_TAUWI_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = rootState.tractionSheaveManual.undercutAngleSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await this.dispatch('tractionSheaveManual/change_TAUWI_storeAction', rootState.tractionSheaveManual.undercutAngleSelection[firstIndex_whichMeetConditions]);
            }
        } else {
            await this.commit('tractionSheaveManual/change_TAUWI_Selection_storeMutation', []);
        }
    },
    async change_SCHMOD_tractionSheavedetails_vgrooveAngleSelection({ rootState, dispatch, commit }, value) {
        if (value != null) {
            await this.commit('tractionSheaveManual/change_TAKWI_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = rootState.tractionSheaveManual.vgrooveAngleSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await this.dispatch('tractionSheaveManual/change_TAKWI_storeAction', rootState.tractionSheaveManual.vgrooveAngleSelection[firstIndex_whichMeetConditions]);
            }
        } else {
            await this.commit('tractionSheaveManual/change_TAKWI_Selection_storeMutation', []);
        }
    },
    checkIf_SCHMOD_inputsManual_areValid_storeAction({ rootState, dispatch, commit }) {
        var numberOf_inputs_whichAreInvalid = 0;
        if (state.schmod_locationProduction == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_certification == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_ProAp == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_motorVoltage == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_PSGSize == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_motorID == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_motorCOSName == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_controller == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_cableLength == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_cableLengthBrake == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_handWheel == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_handRelease == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.schmod_groove == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        //if (state.schmod_numberOfGrooves == null) {
        //    if (state.schmod_numberOfGroovesSelection != null && Array.isArray(state.schmod_numberOfGroovesSelection)) {
        //        if (state.schmod_numberOfGroovesSelection.length == 1) {
        //            if (state.schmod_numberOfGroovesSelection[0].text.text == null || state.schmod_numberOfGroovesSelection[0].text.text == '') {
        //            }
        //            else {
        //                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        //            }
        //        }
        //        else {
        //            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        //        }
        //    }
        //    else {
        //        numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        //    }
        //}


        if (numberOf_inputs_whichAreInvalid > 0) {
            commit('change_schmod_Valid_storeMuation', false);
        }
        else {
            commit('change_schmod_Valid_storeMuation', true);
        }
    },

    async get_detailsSchModValuesSchModData_storeAction({ rootState, commit, dispatch, rootGetters }) {
        const pSG_Variante = {
            produktionsort: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Produktionsort : null,
            zertifizierung: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Zertifizierung : null,
            prodAP: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_ProdAP : null,
            voltage: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Voltage : null,
            pSG_GlobalID_BG: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_GlobalID_BG : null,
            motorID: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_MotorID : null,
            pSGNAM: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_NAM : null,
            pSG_Controller: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Controller : null,
            pSG_Kabellaenge: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Kabellaenge : null,
            pSG_KabellaengeBremse: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_KabellaengeBremse : null,
            pSG_Handradanbau: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Handradanbau : null,
            pSG_Handlueftung: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Handlueftung : null,
            rillenabstand: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Rillenabstand : null,
            rillenform: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_Rillenform : null,
            pSG_No_of_rope_Grooves: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_No_of_rope_Grooves : null,
            mIb1: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_MIb1 : null,
            pSG_OrderStatusMotorCable: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_OrderStatusMotorCable : null,
            pSG_OrderStatusEncoderCable: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_OrderStatusEncoderCable : null,
            pSG_OrderStatusMotorProtectionCable: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_OrderStatusMotorProtectionCable : null,
            pSG_OrderStatusBrakeCable: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_OrderStatusBrakeCable : null,
            pSG_OrderStatusBrakeMonitoringCable: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_OrderStatusBrakeMonitoringCable : null,
            pSG_OrderStatusForcedVentilationCable: (state.motorSchModData != null && state.motorSchModData.psG_ProdAP != null) ? state.motorSchModData.psG_OrderStatusForcedVentilationCable : null,
        }

        if (rootGetters['inputsManual/hasMotorManualData']) {
            await dispatch('change_motorDataSch_storeAction', rootState.inputsManual.motorManualData);
            await dispatch('get_SCHMOD_allSelections_storeAction');
        }
        else {
            await dispatch('get_detailsSchMod_storeAction', pSG_Variante);
        }

    },

    async get_detailsSchModValue_storeAction({ rootState, commit, dispatch }) {

        const pSG_Variante = {
            produktionsort: state.schmod_locationProduction,
            zertifizierung: state.schmod_certification,
            prodAP: state.schmod_ProAp,
            voltage: state.schmod_motorVoltage,
            pSG_GlobalID_BG: state.schmod_PSGSize,
            motorID: state.schmod_motorID,
            pSGNAM: state.schmod_motorCOSName,
            pSG_Controller: state.schmod_controller,
            pSG_Kabellaenge: state.schmod_cableLength,
            pSG_KabellaengeBremse: state.schmod_cableLengthBrake,
            pSG_Handradanbau: state.schmod_handWheel,
            pSG_Handlueftung: state.schmod_handRelease,
            rillenabstand: (state.schmod_grooveDistance != null && state.schmod_grooveDistance.invalid == false) ? state.schmod_grooveDistance.value : null,
            rillenform: state.schmod_groove,
            pSG_No_of_rope_Grooves: state.schmod_numberOfGrooves,
            mIb1: (state.operatingCurrentSplus != null && state.operatingCurrentSplus.invalid == false) ? state.operatingCurrentSplus.value : null,
            pSG_OrderStatusMotorCable: state.schmod_orderStatusMotorCableSelected,
            pSG_OrderStatusEncoderCable: state.schmod_orderStatusEncoderCableSelected,
            pSG_OrderStatusMotorProtectionCable: state.schmod_orderStatusMotorProtectionCableSelected,
            pSG_OrderStatusBrakeCable: state.schmod_orderStatusBrakeCableSelected,
            pSG_OrderStatusBrakeMonitoringCable: state.schmod_orderStatusBrakeMonitoringCableSelected,
            pSG_OrderStatusForcedVentilationCable: state.schmod_orderStatusForcedVentilationCableSelected,
        }
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });


            await this.commit('inputsManual/change_motorManualData_storeMutation', null);
            await commit('change_motorSchModData_storeMutation', null);

            //    await this.dispatch('inputsManual/set_inputManual_Motor_toDefault_storeAction');
            //    await this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
            //    await this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
        await dispatch('get_detailsSchMod_storeAction', pSG_Variante);

    },


    async get_detailsSchMod_storeAction({ rootState, commit, dispatch }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            kid: rootState.manualHome.kid,
            pSG_Variante: value,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_SCHMOD_details',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data.status.statusCode.substring(0, 1) == '2') {
                    dispatch('set_inputManual_SCHMOD_toDefault_storeAction');
                    if (response.data.data.motorData != null) {
                        this.commit('inputsManual/change_motorManualData_storeMutation', response.data.data);
                        if (response.data.data.motorData.hasOwnProperty('kid') && response.data.data.motorData.kid != null) {
                            this.commit('manualHome/change_customerNameOverviewSelected_storeMutation', response.data.data.motorData.kid);
                        }
                        commit('change_motorSchModData_storeMutation', null);
                        if (response.data.data.motorData.hasOwnProperty('detailsSchMod')) {
                            commit('change_motorSchModData_storeMutation', response.data.data.motorData.detailsSchMod);
                        }
                        dispatch('change_motorDataSch_storeAction', response.data.data.motorData);
                    }
                    else {
                        this.commit('inputsManual/change_motorManualData_storeMutation', null);
                        commit('change_motorSchModData_storeMutation', null);
                    }
                }
                else {
                    this.commit('inputsManual/change_motorManualData_storeMutation', null);
                    commit('change_motorSchModData_storeMutation', null);
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                if (state.motorDataSch != null) {
                    dispatch('get_SCHMOD_allSelections_storeAction');
                }
                else {
                    commit('set_showSCHMOD_storeMutation', false);
                }
            })
    },

    change_SCH_magic_storeAction({ rootState, dispatch, commit }, value) {
        commit('set_showSCHMOD_storeMutation', true);
        commit('change_SCH_magic_storeMutation', true)
        dispatch('get_SCHMOD_DefaultAndValuelists_storeAction');
    },
    change_SCHMOD_storeAction({ rootState, dispatch, commit }, value) {
        commit('change_SCH_magic_storeMutation', false)

        if (value == true) {
            dispatch('check_SCHMOD_storeAction');
        }
        else {
            dispatch('get_SCHMOD_DefaultAndValuelists_storeAction');
            dispatch('inputsManual/set_inputsManual_storeAction');
        }
    },

    async change_motorDataSch_storeAction({ commit, dispatch }, value) {
        const data = {
            mtyp: value.details.mtyp,
            mbg: value.details.mbg,
            mfe: value.details.mfe,
            mzus: value.details.mzus,
            smU1: value.details.smU1,
            mnr: value.details.mnr,
            msart: value.details.msart,
            sM250_TS280: false,
            mip: value.details.mip,
            mfbtyp: value.details.mfbtyp,
            mTypK: value.details.mTypK,
            mtyP2: value.details.mtyP2,
            lthd: value.details.lthd,
            preference: value.details.motor_Preference,
            mlS_Law: value.details.mlS_Law,
        }
        await commit('change_motorDataSch_storeMutation', data)
    },
}

const mutations = {
    change_operatingCurrentSplus_storeMutation(state, payload) {
        state.operatingCurrentSplus = payload;
    },

    // SCH-MOD Modul
    change_SCHMOD_locationProductionSelection_storeMutation(state, payload) {
        state.schmod_locationProductionSelection = payload;
    },
    change_SCHMOD_ProdApSelection_storeMutation(state, payload) {
        state.schmod_ProdApSelection = payload;
    },
    change_SCHMOD_PSGSizeSelection_storeMutation(state, payload) {
        state.schmod_PSGSizeSelection = payload;
    },
    change_SCHMOD_motorIDSelection_storeMutation(state, payload) {
        state.schmod_motorIDSelection = payload;
    },
    change_SCHMOD_motorCOSNameSelection_storeMutation(state, payload) {
        state.schmod_motorCOSNameSelection = payload;
    },
    change_SCHMOD_motorVoltageSelection_storeMutation(state, payload) {
        state.schmod_motorVoltageSelection = payload;
    },
    change_SCHMOD_inverterTypeSelection_storeMutation(state, payload) {
        state.schmod_inverterTypeSelection = payload;
    },
    change_SCHMOD_cableLengthSelection_storeMutation(state, payload) {
        state.schmod_cableLengthSelection = payload;
    },
    change_SCHMOD_cableLengthBrakeSelection_storeMutation(state, payload) {
        state.schmod_cableLengthBrakeSelection = payload;
    },
    change_SCHMOD_handWheelSelection_storeMutation(state, payload) {
        state.schmod_handWheelSelection = payload;
    },
    change_SCHMOD_handReleaseSelection_storeMutation(state, payload) {
        state.schmod_handReleaseSelection = payload;
    },
    change_SCHMOD_grooveSelection_storeMutation(state, payload) {
        state.schmod_grooveSelection = payload;
    },
    change_SCHMOD_numberOfGroovesSelection_storeMutation(state, payload) {
        state.schmod_numberOfGroovesSelection = payload;
    },
    change_SCHMOD_orderStatusMotorCableSelection_storeMutation(state, payload) {
        state.schmod_orderStatusMotorCable = payload;
    },
    change_SCHMOD_orderStatusEncoderCableSelection_storeMutation(state, payload) {
        state.schmod_orderStatusEncoderCable = payload;
    },
    change_SCHMOD_orderStatusMotorProtectionCableSelection_storeMutation(state, payload) {
        state.schmod_orderStatusMotorProtectionCable = payload;
    },
    change_SCHMOD_orderStatusBrakeCableSelection_storeMutation(state, payload) {
        state.schmod_orderStatusBrakeCable = payload;
    },
    change_SCHMOD_orderStatusBrakeMonitoringCableSelection_storeMutation(state, payload) {
        state.schmod_orderStatusBrakeMonitoringCable = payload;
    },
    change_SCHMOD_orderStatusForcedVentilationCableSelection_storeMutation(state, payload) {
        state.schmod_orderStatusForcedVentilationCable = payload;
    },
    change_SCHMOD_locationProduction_storeMutation(state, payload) {
        state.schmod_locationProduction = null;
        for (let i = 0; i < state.schmod_locationProductionSelection.length; i++) {
            state.schmod_locationProductionSelection[i].selected = false;

            if (state.schmod_locationProductionSelection[i].text.text == payload) {
                state.schmod_locationProduction = payload;
                state.schmod_locationProductionSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_ProAp_storeMutation(state, payload) {
        state.schmod_ProAp = null;
        for (let i = 0; i < state.schmod_ProdApSelection.length; i++) {
            state.schmod_ProdApSelection[i].selected = false;

            if (state.schmod_ProdApSelection[i].text.text == payload) {
                state.schmod_ProAp = payload;
                state.schmod_ProdApSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_PSGSize_storeMutation(state, payload) {
        state.schmod_PSGSize = null;
        for (let i = 0; i < state.schmod_PSGSizeSelection.length; i++) {
            state.schmod_PSGSizeSelection[i].selected = false;
            if (state.schmod_PSGSizeSelection[i].text.text == payload) {
                state.schmod_PSGSize = payload;
                state.schmod_PSGSizeSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_motorID_storeMutation(state, payload) {
        state.schmod_motorID = null;
        for (let i = 0; i < state.schmod_motorIDSelection.length; i++) {
            state.schmod_motorIDSelection[i].selected = false;

            if (state.schmod_motorIDSelection[i].text.text == payload) {
                state.schmod_motorID = payload;
                state.schmod_motorIDSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_motorCosName_storeMutation(state, payload) {
        state.schmod_motorCOSName = null;
        for (let i = 0; i < state.schmod_motorCOSNameSelection.length; i++) {
            state.schmod_motorCOSNameSelection[i].selected = false;

            if (state.schmod_motorCOSNameSelection[i].text.text == payload) {
                state.schmod_motorCOSName = payload;
                state.schmod_motorCOSNameSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_motorVoltage_storeMutation(state, payload) {
        state.schmod_motorVoltage = null;
        for (let i = 0; i < state.schmod_motorVoltageSelection.length; i++) {
            state.schmod_motorVoltageSelection[i].selected = false;

            if (state.schmod_motorVoltageSelection[i].value == payload) {
                state.schmod_motorVoltage = payload;
                state.schmod_motorVoltageSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_inverterType_storeMutation(state, payload) {
        state.schmod_controller = null;
        for (let i = 0; i < state.schmod_inverterTypeSelection.length; i++) {
            state.schmod_inverterTypeSelection[i].selected = false;

            if (state.schmod_inverterTypeSelection[i].text.text == payload) {
                state.schmod_controller = payload;
                state.schmod_inverterTypeSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_cableLength_storeMutation(state, payload) {
        state.schmod_cableLength = null;
        for (let i = 0; i < state.schmod_cableLengthSelection.length; i++) {
            state.schmod_cableLengthSelection[i].selected = false;

            if (state.schmod_cableLengthSelection[i].text.text == payload) {
                state.schmod_cableLength = payload;
                state.schmod_cableLengthSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_cableLengthBrake_storeMutation(state, payload) {
        state.schmod_cableLengthBrake = null;
        for (let i = 0; i < state.schmod_cableLengthBrakeSelection.length; i++) {
            state.schmod_cableLengthBrakeSelection[i].selected = false;

            if (state.schmod_cableLengthBrakeSelection[i].text.text == payload) {
                state.schmod_cableLengthBrake = payload;
                state.schmod_cableLengthBrakeSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_handWheel_storeMutation(state, payload) {
        state.schmod_handWheel = null;
        for (let i = 0; i < state.schmod_handWheelSelection.length; i++) {
            state.schmod_handWheelSelection[i].selected = false;

            if (state.schmod_handWheelSelection[i].text.text == payload) {
                state.schmod_handWheel = payload;
                state.schmod_handWheelSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_handRelease_storeMutation(state, payload) {
        state.schmod_handRelease = null;
        for (let i = 0; i < state.schmod_handReleaseSelection.length; i++) {
            state.schmod_handReleaseSelection[i].selected = false;

            if (state.schmod_handReleaseSelection[i].text.text == payload) {
                state.schmod_handRelease = payload;
                state.schmod_handReleaseSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_orderStatusMotorCable_storeMutation(state, payload) {
        state.schmod_orderStatusMotorCableSelected = null;
        if (state.schmod_orderStatusMotorCable.disabled == false && state.schmod_orderStatusMotorCable.hasOwnProperty('selection')) {
            for (let i = 0; i < state.schmod_orderStatusMotorCable.selection.length; i++) {
                state.schmod_orderStatusMotorCable.selection[i].selected = false;

                if (state.schmod_orderStatusMotorCable.selection[i].text.code == payload) {
                    state.schmod_orderStatusMotorCableSelected = payload;
                    state.schmod_orderStatusMotorCable.selection[i].selected = true;
                }
            }
        }
    },
    change_SCHMOD_orderStatusEncoderCable_storeMutation(state, payload) {
        state.schmod_orderStatusEncoderCableSelected = null;
        if (state.schmod_orderStatusEncoderCable.disabled == false && state.schmod_orderStatusEncoderCable.hasOwnProperty('selection')) {
            for (let i = 0; i < state.schmod_orderStatusEncoderCable.selection.length; i++) {
                state.schmod_orderStatusEncoderCable.selection[i].selected = false;

                if (state.schmod_orderStatusEncoderCable.selection[i].text.code == payload) {
                    state.schmod_orderStatusEncoderCableSelected = payload;
                    state.schmod_orderStatusEncoderCable.selection[i].selected = true;
                }
            }
        }
    },
    change_SCHMOD_orderStatusMotorProtectionCable_storeMutation(state, payload) {
        state.schmod_orderStatusMotorProtectionCableSelected = null;
        if (state.schmod_orderStatusMotorProtectionCable.disabled == false && state.schmod_orderStatusMotorProtectionCable.hasOwnProperty('selection')) {
            for (let i = 0; i < state.schmod_orderStatusMotorProtectionCable.selection.length; i++) {
                state.schmod_orderStatusMotorProtectionCable.selection[i].selected = false;

                if (state.schmod_orderStatusMotorProtectionCable.selection[i].text.code == payload) {
                    state.schmod_orderStatusMotorProtectionCableSelected = payload;
                    state.schmod_orderStatusMotorProtectionCable.selection[i].selected = true;
                }
            }
        }
    },
    change_SCHMOD_orderStatusBrakeCable_storeMutation(state, payload) {
        state.schmod_orderStatusBrakeCableSelected = null;
        if (state.schmod_orderStatusBrakeCable.disabled == false && state.schmod_orderStatusBrakeCable.hasOwnProperty('selection')) {
            for (let i = 0; i < state.schmod_orderStatusBrakeCable.selection.length; i++) {
                state.schmod_orderStatusBrakeCable.selection[i].selected = false;

                if (state.schmod_orderStatusBrakeCable.selection[i].text.code == payload) {
                    state.schmod_orderStatusBrakeCableSelected = payload;
                    state.schmod_orderStatusBrakeCable.selection[i].selected = true;
                }
            }
        }
    },
    change_SCHMOD_orderStatusBrakeMonitoringCable_storeMutation(state, payload) {
        state.schmod_orderStatusBrakeMonitoringCableSelected = null;
        if (state.schmod_orderStatusBrakeMonitoringCable.disabled == false && state.schmod_orderStatusBrakeMonitoringCable.hasOwnProperty('selection')) {
            for (let i = 0; i < state.schmod_orderStatusBrakeMonitoringCable.selection.length; i++) {
                state.schmod_orderStatusBrakeMonitoringCable.selection[i].selected = false;

                if (state.schmod_orderStatusBrakeMonitoringCable.selection[i].text.code == payload) {
                    state.schmod_orderStatusBrakeMonitoringCableSelected = payload;
                    state.schmod_orderStatusBrakeMonitoringCable.selection[i].selected = true;
                }
            }
        }
    },
    change_SCHMOD_orderStatusForcedVentilationCable_storeMutation(state, payload) {
        state.schmod_orderStatusForcedVentilationCableSelected = null;
        if (state.schmod_orderStatusForcedVentilationCable.disabled == false && state.schmod_orderStatusForcedVentilationCable.hasOwnProperty('selection')) {
            for (let i = 0; i < state.schmod_orderStatusForcedVentilationCable.selection.length; i++) {
                state.schmod_orderStatusForcedVentilationCable.selection[i].selected = false;

                if (state.schmod_orderStatusForcedVentilationCable.selection[i].text.code == payload) {
                    state.schmod_orderStatusForcedVentilationCableSelected = payload;
                    state.schmod_orderStatusForcedVentilationCable.selection[i].selected = true;
                }
            }
        }
    },
    change_SCHMOD_grooveDistance_storeMutation(state, payload) {
        state.schmod_grooveDistance = payload;
    },
    change_SCHMOD_groove_storeMutation(state, payload) {
        state.schmod_groove = null;
        for (let i = 0; i < state.schmod_grooveSelection.length; i++) {
            state.schmod_grooveSelection[i].selected = false;

            if (state.schmod_grooveSelection[i].text.text == payload) {
                state.schmod_groove = payload;
                state.schmod_grooveSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_numberOfGrooves_storeMutation(state, payload) {
        state.schmod_numberOfGrooves = null;
        for (let i = 0; i < state.schmod_numberOfGroovesSelection.length; i++) {
            state.schmod_numberOfGroovesSelection[i].selected = false;

            if (state.schmod_numberOfGroovesSelection[i].text.text == payload) {
                state.schmod_numberOfGrooves = payload;
                state.schmod_numberOfGroovesSelection[i].selected = true;
            }
        }
    },
    change_SCHMOD_certificationSelection_storeMutation(state, payload) {
        state.schmod_certificationSelection = payload;
    },
    change_SCHMOD_certification_storeMutation(state, payload) {
        for (let i = 0; i < state.schmod_certificationSelection.length; i++) {
            state.schmod_certificationSelection[i].selected = false;

            if (state.schmod_certificationSelection[i].text.text == payload) {
                state.schmod_certification = payload;
                state.schmod_certificationSelection[i].selected = true;
            }
        }
    },
    change_schmod_Valid_storeMuation(state, payload) {
        state.schmod_Valid = payload;
    },
    change_SchModDetails_storeMuation(state, payload) {
        state.schModDetails = payload;
    },
    change_SCHMOD_Motordetails_storeMutation(state, payload) {
        state.schmodMotordetails = payload;
    },
    set_showSCHMOD_storeMutation(state, payload) {
        state.showSCHMOD = payload;
    },
    change_SCH_magic_storeMutation(state, payload) {
        state.psgMagic = payload;
    },
    change_SCH_psgMenu_storeMutation(state, payload) {
        state.psgMenu = payload;
    },
    change_motorDataSch_storeMutation(state, payload) {
        state.motorDataSch = payload;
    },
    change_motorSchModData_storeMutation(state, payload) {
        state.motorSchModData = payload;
    },
}

const getters = {
    inputData: (state, getters, rootState, rootGetters) => {

        const diameter = ((rootState.tractionSheaveManual.deliverTractionSheave == null || rootState.tractionSheaveManual.deliverTractionSheave == 0)
            && (rootGetters['ropeGuardManual/deliverRope'] == null || rootGetters['ropeGuardManual/deliverRope'] == 0))
            ? null
            : (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter : null);
        const width = ((rootState.tractionSheaveManual.deliverTractionSheave == null || rootState.tractionSheaveManual.deliverTractionSheave == 0)
            && (rootGetters['ropeGuardManual/deliverRope'] == null || rootGetters['ropeGuardManual/deliverRope'] == 0))
            ? null
            : (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width : null);

        const psg_Handradanbau = state.motorSchModData != null ? state.motorSchModData.psG_Handradanbau : null;
        const psg_Handlueftung = state.motorSchModData != null ? state.motorSchModData.psG_Handlueftung : null;
        const psg_Kabellaenge = state.motorSchModData != null ? state.motorSchModData.psG_Kabellaenge : null;
        const psg_KabellaengeBremse = state.motorSchModData != null ? state.motorSchModData.psG_KabellaengeBremse : null;
        const psg_Reglerart = state.motorSchModData != null ? state.motorSchModData.psG_Reglerart : null;
        const psg_NAM = state.motorSchModData != null ? state.motorSchModData.psG_NAM : null;
        const psg_Rillenform = state.motorSchModData != null ? state.motorSchModData.psG_Rillenform : null;
        const psg_Produktionsort = state.motorSchModData != null ? state.motorSchModData.psG_Produktionsort : null;
        const psg_Zertifizierung = state.motorSchModData != null ? state.motorSchModData.psG_Zertifizierung : null;
        const psg_ProdAP = state.motorSchModData != null ? state.motorSchModData.psG_ProdAP : null;
        const psg_Voltage = state.motorSchModData != null ? state.motorSchModData.psG_Voltage : null;
        const psg_GlobalID_BG = state.motorSchModData != null ? state.motorSchModData.psG_GlobalID_BG : null;
        const psg_MotorID = state.motorSchModData != null ? state.motorSchModData.psG_MotorID : null;
        const psg_Rillenabstand = state.motorSchModData != null ? state.motorSchModData.psG_Rillenabstand : null;
        const psg_No_of_rope_Grooves = state.motorSchModData != null ? state.motorSchModData.psG_No_of_rope_Grooves : null;
        const psg_MIb1 = state.motorSchModData != null ? state.motorSchModData.psG_MIb1 : null;
        const psg_MBG = state.motorSchModData != null ? state.motorSchModData.psG_MBG : null;
        const psg_MFE = state.motorSchModData != null ? state.motorSchModData.psG_MFE : null;
        const psg_ID = state.motorSchModData != null ? state.motorSchModData.psG_ID : null;
        const psg_MNR = state.motorSchModData != null ? state.motorSchModData.psG_MNR : null;
        const psG_Controller = state.motorSchModData != null ? state.motorSchModData.psG_Controller : null;
        const psG_OrderStatusMotorCable = state.motorSchModData != null ? state.motorSchModData.psG_OrderStatusMotorCable : null;
        const psG_OrderStatusEncoderCable = state.motorSchModData != null ? state.motorSchModData.psG_OrderStatusEncoderCable : null;
        const psG_OrderStatusMotorProtectionCable = state.motorSchModData != null ? state.motorSchModData.psG_OrderStatusMotorProtectionCable : null;
        const psG_OrderStatusBrakeCable = state.motorSchModData != null ? state.motorSchModData.psG_OrderStatusBrakeCable : null;
        const psG_OrderStatusBrakeMonitoringCable = state.motorSchModData != null ? state.motorSchModData.psG_OrderStatusBrakeMonitoringCable : null;
        const psG_OrderStatusForcedVentilationCable = state.motorSchModData != null ? state.motorSchModData.psG_OrderStatusForcedVentilationCable : null;

        return {
            mTYP: state.motorSchModData != null ? state.motorDataSch.mtyp : null,
            mBG: state.motorSchModData != null ? state.motorDataSch.mbg : null,
            mFE: state.motorSchModData != null ? state.motorDataSch.mfe : null,
            mZUS: state.motorSchModData != null ? state.motorDataSch.mzus : null,
            mU1: state.motorSchModData != null ? state.motorDataSch.smU1 : null,
            mNR: state.motorSchModData != null ? state.motorDataSch.mnr : null,
            mLS_Law: state.motorSchModData != null ? state.motorDataSch.mlS_Law : null,
            motor_Preference: state.motorSchModData != null ? state.motorDataSch.preference : null,
            mSART: state.motorSchModData != null ? state.motorDataSch.msart : null,
            mIP: rootGetters['inputsManual/mip'],
            motor_ForcedVentilationWithBrakeRelease: rootGetters['inputsManual/forcedVentilationWithBrakeRelease'],
            mFBTYP: rootGetters['inputsManual/MFBTYP'], 
            tNFB: rootGetters['inputsManual/tnfb'],
            lTR: rootState.tractionSheaveManual.deliverTractionSheave,
            lTHD: state.motorSchModData != null ? state.motorDataSch.lthd : null,
            tD: diameter,
            tB: width,
            tARILL: rootState.tractionSheaveManual.sheaveProfile,
            tAUWI: rootState.tractionSheaveManual.undercutAngle,
            tAKWI: rootState.tractionSheaveManual.vgrooveAngle,
            tCSD: rootState.tractionSheaveManual.ropeDiameter,
            tDRA: rootState.tractionSheaveManual.grooveDistance,
            tDRZ: rootState.tractionSheaveManual.numberOfGrooves,
            kIDSCH: rootGetters['ropeGuardManual/customerIdKid'],
            fUESSE: rootGetters['ropeGuardManual/positionMotor'],
            sEILAB: rootGetters['ropeGuardManual/ropePull'],
            eINST: rootGetters['ropeGuardManual/adjustability'],
            lSEILS: rootGetters['ropeGuardManual/deliverRope'],
            lTSABD: rootGetters['ropeGuardManual/tractionSheaveCover'],
            lTKLEM: rootGetters['ropeGuardManual/ropeClamp'],
            lRUEV: rootGetters['ropeGuardManual/lruev'],
            mN_SAS: rootGetters['ropeGuardManual/thirdRopeGuard'],
            sM250_TS280: state.motorSchModData != null ? state.motorDataSch.sM250_TS280 : null,
            pSG_Handradanbau: psg_Handradanbau,
            pSG_Handlueftung: psg_Handlueftung,
            pSG_Kabellaenge: psg_Kabellaenge,
            pSG_KabellaengeBremse: psg_KabellaengeBremse,
            pSG_Reglerart: psg_Reglerart,
            pSG_NAM: psg_NAM,
            pSG_Rillenform: psg_Rillenform,
            psg_Produktionsort: psg_Produktionsort,
            psg_Zertifizierung: psg_Zertifizierung,
            psg_ProdAP: psg_ProdAP,
            psg_Voltage: psg_Voltage,
            psg_GlobalID_BG: psg_GlobalID_BG,
            psg_MotorID: psg_MotorID,
            psg_Rillenabstand: psg_Rillenabstand,
            psg_No_of_rope_Grooves: psg_No_of_rope_Grooves,
            psg_MIb1: psg_MIb1,
            psg_MBG: psg_MBG,
            psg_MFE: psg_MFE,
            psg_ID: psg_ID,
            psg_MNR: psg_MNR,
            psG_Controller: psG_Controller,
            psG_OrderStatusMotorCable: psG_OrderStatusMotorCable,
            psG_OrderStatusEncoderCable: psG_OrderStatusEncoderCable,
            psG_OrderStatusMotorProtectionCable: psG_OrderStatusMotorProtectionCable,
            psG_OrderStatusBrakeCable: psG_OrderStatusBrakeCable,
            psG_OrderStatusBrakeMonitoringCable: psG_OrderStatusBrakeMonitoringCable,
            psG_OrderStatusForcedVentilationCable: psG_OrderStatusForcedVentilationCable,
        }

    },
}

export const psgModal = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations,
    getters
}